const AlertAckBlueHeader = () => {
  return (
    <svg width="100%" height="150" viewBox="0 0 390 150" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <path d="M390 0V150C233.489 104.234 148.123 104.865 0 150V0H390Z" fill="url(#paint0_linear_11051_5598)" />
      <defs>
        <linearGradient id="paint0_linear_11051_5598" x1="175" y1="44.8113" x2="212.167" y2="133.215" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8FBAE2" />
          <stop offset="0.92778" stopColor="#B4D0E4" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default AlertAckBlueHeader
